/**
 * Hesabım — kullanıcının profil bilgilerini gösteren read-only diyalog.
 * Backend'e yazma yapmaz; sadece AuthContext'ten okur.
 */
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { User, Mail, Building2, ShieldCheck, IdCard } from "lucide-react";

const ROLE_LABELS = {
  admin: "Yönetici",
  sistem_yoneticisi: "Sistem Yöneticisi",
  member: "Kullanıcı",
  operator: "Operatör",
  muhasebe: "Muhasebe",
  satis: "Satış",
  uretim: "Üretim",
  depo: "Depo",
};

function humanizeRole(user) {
  if (!user) return "-";
  if (user.is_super_admin) return "Süper Yönetici";
  const key = (user.role_code || user.role || "").toLowerCase();
  return ROLE_LABELS[key] || (user.role_code || user.role || "-");
}

export default function AccountInfoDialog({ open, onOpenChange, user }) {
  const rows = [
    { icon: User, label: "Ad Soyad", value: user?.name || "-", testId: "acc-name" },
    { icon: Mail, label: "E-posta", value: user?.email || "-", testId: "acc-email" },
    { icon: ShieldCheck, label: "Rol", value: humanizeRole(user), testId: "acc-role" },
    { icon: Building2, label: "Firma", value: user?.company_name || user?.company_id || "-", testId: "acc-company" },
    { icon: IdCard, label: "Şirket ID", value: user?.company_id || "-", testId: "acc-company-id", mono: true },
  ];
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-slate-900 border-slate-800 text-slate-100 rounded-sm max-w-md" data-testid="account-info-dialog">
        <DialogHeader>
          <DialogTitle className="text-slate-100 uppercase text-xs tracking-widest font-semibold">
            Hesabım
          </DialogTitle>
        </DialogHeader>
        <div className="space-y-3 py-2">
          {rows.map((r, i) => (
            <div key={i} className="flex items-start gap-3 px-3 py-2 rounded-sm border border-slate-800 bg-slate-950/40">
              <r.icon className="w-4 h-4 text-blue-400 mt-0.5 flex-shrink-0" />
              <div className="min-w-0 flex-1">
                <div className="text-[10px] uppercase tracking-widest text-slate-500 font-mono">{r.label}</div>
                <div className={`text-sm text-slate-100 truncate ${r.mono ? "font-mono" : ""}`} data-testid={r.testId} title={r.value}>
                  {r.value}
                </div>
              </div>
            </div>
          ))}
        </div>
      </DialogContent>
    </Dialog>
  );
}
